exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ontology-search[data-v-a51553fc]{height:100%;padding:2em;padding-top:0}.ontology-search__bottom-container[data-v-a51553fc]{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%}.ontology-search-container[data-v-a51553fc]{width:80%}.filters-container[data-v-a51553fc]{width:20%;margin-left:1em}.ontology-search-graph[data-v-a51553fc]{margin-bottom:3em;height:80%}.ontology-search-table[data-v-a51553fc]{padding-bottom:6vh}.ontology-search-information[data-v-a51553fc]{margin-bottom:1.5em}", ""]);

// exports
